import React from "react";
import { ToggleButton } from "@mui/lab";
import styled from "styled-components";
import { useAuth } from "src/components/providers/auth-context";

const StyledToggleButton = styled(ToggleButton)`
    font-size: 12px;
    text-transform: none;
    font-weight: 300;
    width: 150px;
`;

const ButtonContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin: -6px;
    & > * {
        margin: 6px;
    }
`;

const CaseAnalysisCategoryToggle = ({ selectedCategory, setSelectedCategory }) => {
    const handleChange = (event, newCategory) => {
        if (newCategory !== null) {
            setSelectedCategory(newCategory);
        }
    };
    const { userHasTeamsSubscription } = useAuth();
    return (
        <ButtonContainer>
            <StyledToggleButton
                value="personal"
                selected={selectedCategory === "personal"}
                onClick={() => handleChange(null, "personal")}
            >
                Personal
            </StyledToggleButton>
            <StyledToggleButton
                value="team"
                selected={selectedCategory === "team"}
                disabled={!userHasTeamsSubscription}
                onClick={() => handleChange(null, "team")}
            >
                Team
            </StyledToggleButton>
            <StyledToggleButton
                value="organization"
                selected={selectedCategory === "organization"}
                disabled={!userHasTeamsSubscription}
                onClick={() => handleChange(null, "organization")}
            >
                Organization
            </StyledToggleButton>
        </ButtonContainer>
    );
};

export default CaseAnalysisCategoryToggle;
